export default __webpack_public_path__ + "images/license-riscage-2.cd7ef32793a8b0f0c597d015620229fa.png";